/** Das Symbol einer Liste (F-33) als Komponente - der Schluessel kommt aus den Daten. */
import { createElement } from 'react';

import { symbolVon } from '@/modules/listen/symbole';

export function ListenSymbol({ symbol, className }: { symbol: string; className?: string }) {
  return createElement(symbolVon(symbol), { className, 'aria-hidden': true });
}
